<script setup>
import { useSettings } from '~/store/settings'

const store = useSettings()
const isDataFree = store.isDataFree
</script>

<template>
  <slot v-if="!isDataFree" />
</template>
